import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/staff-schedule";

export const saveOrUpdateScheduleStaff = staff => axios.post(API_PATH + "/save-or-update", staff);

export const saveOrUpdateListSchedule = staff => axios.post(API_PATH + "/save-or-update-list-schedule", staff);

export const getScheduleStaffById = staffId => axios.get(API_PATH + "/getbyid/" + staffId);

export const deleteScheduleStaff = staffId => axios.delete(API_PATH + "/mark-delete/" + staffId);

export const pagingScheduleStaff = searchScheduleStaff => axios.post(API_PATH + "/search-by-page", searchScheduleStaff);

export const getAllScheduleStaff = (searchObj) => axios.post(API_PATH + "/search-by-page", searchObj);

export const generateScheduleForStaff = (searchObj) => axios.post(API_PATH + "/generate-schedule-for-staff", searchObj);

export const getListStaffSchedule = (searchObj) => axios.post(API_PATH + "/get-list-staff-schedule", searchObj);

export const checkOverlapListSchedule = (searchObj) => axios.post(API_PATH + "/check-overlap-list-schedule", searchObj);
